
import { Component, Vue, Watch } from 'vue-property-decorator'
import AddBasic from './component/add-basic.vue'
import AddPrice from './component/add-price.vue'
import AddDetails from './component/add-details.vue'
import AddSales from './component/add-sales.vue'
import AddLogistics from './component/add-logistics.vue'
import { apiGoodsAdd, apiGoodsEdit, apiGoodsOtherList, apiKpGoodsPoolDetail } from '@/api/goods'
import { apiGatherGoodsDetails, apiGatherGoodsEdit } from '@/api/application/goods_collection'
@Component({
    components: {
        AddBasic,
        AddPrice,
        AddDetails,
        AddSales,
        AddLogistics
    }
})
export default class KpGoodsRelease extends Vue {
    $refs!: { form: any }
    // 商品id
    id!: any
    isGatherGoods!: any
    loading = true
    activeName = 'basic'
    otherList = {
        supplier_list: [],
        category_list: [],
        brand_list: [],
        unit_list: [],
        freight_list: []
    }
    // 必传字段与对应的选项卡名字
    requireFields = [
        {
            fields: ['code', 'name', 'category_id', 'goods_image'],
            activeName: 'basic'
        },
        {
            fields: ['skus[0].sell_price', 'skus[0].stock'],
            activeName: 'price'
        },
        {
            fields: ['express_money', 'express_template_id', 'delivery_content'],
            activeName: 'logistics'
        }
    ]
    // 规格绑定的数据
    specData: any = {
        specGroup: [],
        skus: [],
        specificationType: 1,
        specs_single: []
    }
    // 表单
    form: any = {
        goods_image: [],
        skus: [
            {
                id: '',
                image: '',
                sell_price: '',
                lineation_price: '',
                cost_price: '',
                stock: '',
                volume: '',
                weight: '',
                bar_code: ''
            }
        ]
    }
    // 规则验证
    rules = {
        title: [
            {
                required: true,
                message: '请输入商品名称',
                trigger: ['blur', 'change']
            }
        ],
        code: [
            {
                required: true,
                message: '请输入商品编码',
                trigger: ['blur', 'change']
            }
        ],
        category_id: [
            {
                type: 'array',
                required: true,
                message: '请选择分类',
                trigger: ['blur', 'change']
            }
        ],
        goods_image: [
            {
                type: 'array',
                required: true,
                message: '请添加商品轮播图',
                trigger: ['blur', 'change']
            }
        ],
        video: [
            {
                required: true,
                message: '请添加视频',
                trigger: ['blur', 'change']
            }
        ],
        express_money: [
            {
                required: true,
                message: '请输入运费金额',
                trigger: ['blur', 'change']
            }
        ],
        express_template_id: [
            {
                required: true,
                message: '请选择运费模板',
                trigger: ['blur', 'change']
            }
        ],
        delivery_content: [
            {
                required: true,
                message: '请输入发货内容',
                trigger: ['blur', 'change']
            }
        ]
    }

    @Watch('form', { deep: true })
    formChange(val: any) {}
    @Watch('specData', { deep: true })
    specDataChange(val: any) {
        this.form.spec_type = val.specificationType
        if (val.spec_type == 1) {
            this.form.spec_value_list = [val.specs_single]
            this.form.spec_value = []
            return
        }
        this.form.spec_value_list = val.skus
        this.form.spec_value = val.specGroup
    }
    // methods
    getGoodsDetail() {
        apiKpGoodsPoolDetail({ id: this.id })
            .then((res: any) => {
                this.initData(res)
                this.form = res
            })
            .catch(rej => {
                this.loading = false
                this.$router.back()
            })
    }

    getGoodsCollectionDetail() {
        apiGatherGoodsDetails(this.id)
            .then((res: any) => {
                this.initData(res)
                this.form = res
                if (this.form.poster === null) {
                    this.form.poster = ''
                }
                if (this.form.video_source === null) {
                    this.form.video_source = 1
                }
            })
            .catch(() => {
                this.$router.back()
            })
    }

    onNextStep(isNext = true) {
        switch (this.activeName) {
            case 'basic':
                this.activeName = 'price'
                break
            case 'price':
                this.activeName = isNext ? 'logistics' : 'basic'
                break
            case 'logistics':
                this.activeName = isNext ? 'details' : 'price'
                break
            case 'details':
                this.activeName = isNext ? 'sales' : 'logistics'
                break
            case 'sales':
                this.activeName = 'details'
                break
        }
    }

    handleSave() {
        this.$refs.form.validate((valid: boolean, object: any) => {
            if (valid) {
                const loading = this.$loading({
                    lock: true,
                    text: '保存中...',
                    spinner: 'el-icon-loading'
                })
                let api = null
                if (this.isGatherGoods) {
                    api = apiGatherGoodsEdit(this.form)
                } else {
                    api = this.id ? apiGoodsEdit(this.form) : apiGoodsAdd(this.form)
                }
                api.then(() => {
                    this.$router.go(-1)
                }).finally(() => {
                    loading.close()
                })
            } else {
                const fieldsitem = this.requireFields.find(item => {
                    for (const value of item.fields) {
                        if (object[value]) {
                            this.$message.error(object[value][0].message)
                            return true
                        }
                    }
                })
                fieldsitem && (this.activeName = fieldsitem.activeName)
                return false
            }
        })
    }
    // 初始化规格数据
    initData(data: any = {}) {
        // const spec_value = [
        //     {
        //         has_image: false,
        //         id: '',
        //         name: '',
        //         spec_list: [
        //             {
        //                 id: '',
        //                 value: '',
        //                 image: ''
        //             }
        //         ]
        //     }
        // ]

        // const spec_value_list = [
        //     {
        //         id: '',
        //         image: '',
        //         sell_price: '',
        //         lineation_price: '',
        //         cost_price: '',
        //         stock: '',
        //         volume: '',
        //         weight: '',
        //         bar_code: ''
        //     }
        // ]
        const specGroup = [
            {
                has_image: false,
                id: '',
                specificationName: '',
                specList: [
                    {
                        id: '',
                        value: '',
                        img: ''
                    }
                ]
            }
        ]
        const skus = [
            {
                id: '',
                costPrice: '',
                img: '',
                marketPrice: '',
                productId: '',
                salePrice: '',
                settlementPrice: '',
                specificationCode: '',
                specificationValue: '',
                specificationValueId: '',
                state: '',
                stateMsg: '',
                stock: '',
                volume: '',
                weight: ''
            }
        ]
        const specData: any = {
            specGroup: data.specGroup || specGroup,
            skus: data.skus || skus,
            specificationType: data.specificationType || 1,
            specs_single: skus[0]
        }
        specData.specGroup.forEach((item: any) => {
            item.has_image = false
            item.specList.forEach((sitem: any) => {
                sitem.img = ''
            })
        })

        if (data.specificationType == 1) {
            specData.specGroup = specGroup
            specData.specs_single = data.skus[0]
        }
        Object.assign(this.specData, specData)
        this.loading = false
    }

    getGoodsOtherList() {
        // apiGoodsOtherList({
        //     type: 'all'
        // }).then((res: any) => {
        //     this.otherList = res
        // })
    }
    created() {
        this.id = this.$route.query.id
        this.isGatherGoods = this.$route.query.type || ''

        this.getGoodsOtherList()
        if (this.isGatherGoods) {
            this.getGoodsCollectionDetail()
            return
        }
        if (this.id) {
            this.getGoodsDetail()
            return
        }
        this.initData()
    }
}
